// src/modules/app-views/omnichannel/pages/Init/components/ContextFlagDivider.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tag } from 'antd';
import {
  SwapOutlined,
  PoweroffOutlined,
  RiseOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const ContextFlagDivider = ({ type, isDark }) => {
  const config = getConfig(type);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '8px 0 16px',
      }}
    >
      <Tag
        icon={config.icon}
        color={config.color}
        style={{
          fontSize: 11,
          fontWeight: 500,
          padding: '3px 10px',
          borderRadius: 8,
          border: 'none',
          boxShadow: isDark
            ? '0 1px 2px rgba(0,0,0,0.3)'
            : '0 1px 2px rgba(11,20,26,0.1)',
        }}
      >
        {translateX(config.text)}
      </Tag>
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ContextFlagDivider;

// *******************************************************************************
// HELPERS
// *******************************************************************************
function getConfig(type) {
  switch (type) {
    case 'closed':
      return {
        icon: <PoweroffOutlined />,
        color: 'volcano',
        text: 'context_closed',
      };
    case 'escalated':
      return {
        icon: <RiseOutlined />,
        color: 'blue',
        text: 'context_escalated',
      };
    case 'transferred':
      return {
        icon: <SwapOutlined />,
        color: 'orange',
        text: 'transfer_conversation',
      };
    case 'new_context':
      return {
        icon: <PlusCircleOutlined />,
        color: 'green',
        text: 'new_context',
      };
    default:
      return {
        icon: <SwapOutlined />,
        color: 'default',
        text: 'new_context',
      };
  }
}
